import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import React from "react"
import Grid from "@mui/material/Grid"
import Button from "@mui/material/Button"
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined"
import LocalFireDepartmentOutlinedIcon from "@mui/icons-material/LocalFireDepartmentOutlined"
import SportsScoreOutlinedIcon from "@mui/icons-material/SportsScoreOutlined"
import PublicOutlinedIcon from "@mui/icons-material/PublicOutlined"
import TimerOutlinedIcon from "@mui/icons-material/TimerOutlined"
import parse from "html-react-parser"

const Panel = ({ title, children, sx }) => (
  <Box
    sx={{
      height: "100%",
      p: {
        xs: 2,
        md: 2.2,
      },
      borderRadius: 1,
      border: "1px solid rgba(196,150,84,0.2)",
      background: "linear-gradient(180deg, #000 60%, #121212 100%)",
      ...sx,
    }}
  >
    {title && (
      <Typography variant="h4" mb={2}>
        {title}
      </Typography>
    )}

    {children}
  </Box>
)

export default function Overview({ tournament }) {
  return (
    <Grid container spacing={2.4}>
      <Grid item xs={12} md={4}>
        <Panel title="About This Tournament">
          <Typography sx={{ fontSize: "1.1rem", color: "#dedede" }}>
            {parse(tournament.description || "")}
          </Typography>
        </Panel>
      </Grid>

      <Grid item xs={12} md={4}>
        <Panel title="Tournament info">
          {[
            {
              icon: <CalendarTodayOutlinedIcon />,
              label: "Start Time",
              value: tournament.start_at,
            },
            {
              icon: <CalendarTodayOutlinedIcon />,
              label: "End Time",
              value: tournament.end_at,
            },
            {
              icon: <LocalFireDepartmentOutlinedIcon />,
              label: "Max Attempts",
              value: tournament.max_attempts,
            },
            {
              icon: <SportsScoreOutlinedIcon />,
              label: "Score System",
              value: "Points for killing zombies",
            },
            {
              icon: <TimerOutlinedIcon />,
              label: "Platform fee",
              value: tournament.platform_fee,
            },
            {
              icon: <PublicOutlinedIcon />,
              label: "Region",
              value: "Global",
            },
          ].map((item) => (
            <Box
              key={item.label}
              sx={{
                display: "grid",
                gridTemplateColumns: "minmax(110px, 0.9fr) 1fr",
                gap: 1.5,
                alignItems: "start",
                py: 1,
                borderBottom: "1px solid rgba(198,146,76,0.1)",
                "&:last-of-type": {
                  borderBottom: "none",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.8,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    color: "#827b72",
                    "& svg": {
                      fontSize: 17,
                    },
                  }}
                >
                  {item.icon}
                </Box>

                <Typography
                  sx={{
                    color: "#dedede",
                    fontSize: 16,
                  }}
                >
                  {item.label}
                </Typography>
              </Box>

              <Typography
                sx={{
                  color: "#dedede",
                  fontSize: 16,
                  fontWeight: 700,
                }}
              >
                {item.value}
              </Typography>
            </Box>
          ))}
        </Panel>
      </Grid>

      <Grid item xs={12} md={4}>
        <Panel title="Your Tournament Stats">
          <Box
            sx={{
              display: "grid",
              gap: 1.2,
            }}
          >
            {[
              ["Best Score", "85,230"],
              ["Current Rank", "8 / 184"],
              ["Attempts", `1 / ${tournament.max_attempts}`],
              ["Estimated Reward", "25 USDT"],
            ].map(([label, value], index) => (
              <Box
                key={label}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                  pb: 1.1,
                  borderBottom: "1px solid rgba(198,146,76,0.1)",
                }}
              >
                <Typography
                  sx={{
                    color: "#dedede",
                    fontSize: 16,
                  }}
                >
                  {label}
                </Typography>

                <Typography
                  sx={{
                    color: index === 1 || index === 3 ? "#35c66b" : "#d7d0c3",
                    fontSize: 16,
                    fontWeight: 900,
                  }}
                >
                  {value}
                </Typography>
              </Box>
            ))}
          </Box>

          <Button
            variant="contained"
            size="large"
            fullWidth
            sx={{ mt: 2 }}
            disabled
          >
            Play now
          </Button>
        </Panel>
      </Grid>
    </Grid>
  )
}
